import Axios from 'axios';

const apiURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_URL : process.env.REACT_APP_OTHER_API_URL;

export const axiosInstance = Axios.create({
  baseURL: apiURL, // Set your backend server URL here
});
